import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import * as orderHandler from "@/js/order/order.js";
import { ERROR_DATA } from "@/js/forms.js";
var defaultStyleOptions = {
  color: "primary",
  width: 725,
  maxWidth: "85%",
  zIndex: 2000,
  isHtmlMessage: false
};
var defaultDialogOptions = {
  showMessage: false,
  showTitle: false,
  hideDefaultMessage: false,
  hideDefaultFooterMessage: false
};
export default {
  name: "ErrorModal",
  data: function data() {
    return {
      dialogType: null,
      message: null,
      title: null,
      btnAdditionals: null,
      dialogOptions: _objectSpread({}, defaultDialogOptions),
      styleOptions: _objectSpread({}, defaultStyleOptions),
      dialog: false,
      resolve: null,
      reject: null,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isMessageDefault: function isMessageDefault() {
      return this.message == ERROR_DATA.TOASTER_TYPES.ERROR.defaultMessage || this.message == ERROR_DATA.TOASTER_TYPES.ERROR.messageIfCompleteExceptionConsole;
    }
  },
  created: function created() {},
  methods: {
    open: function open(dialogType, message) {
      var _this = this;
      var dialogOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var styleOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var btnAdditionals = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      this.dialogType = dialogType;
      this.dialogOptions = _objectSpread(_objectSpread({}, defaultDialogOptions), dialogOptions);
      this.title = title;
      this.message = message;
      this.styleOptions = _objectSpread(_objectSpread({}, defaultStyleOptions), styleOptions);
      this.btnAdditionals = btnAdditionals;
      this.dialog = true;
      return new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    reloadPage: function reloadPage() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var basket;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return orderHandler.fetchBasket();
            case 2:
              basket = _context.sent;
              orderHandler.setCurrentOrder(basket.data);
              window.location.reload();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};